import React from "react";
import { Paper, Stack, styled, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";
import NavDrawer from "../helpers/NavDrawer";
import ProfileNavBar from "./ProfileNavBar";

// const StyledPaper = styled(Paper)`
//   display: flex;
//   height: 100%;
//   width: 100%;
//   padding: 4em 0;
// `;

// Modified the style with light and dark theme
const StyledPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1e293b' : 'white',
  color: theme.palette.mode === 'dark' ? 'white' : 'black',
  padding: '16px',
  borderRadius: '8px',
  height: '100%',
  width: '100%',
  padding: '4em 0',
}));


const ProfileLayout = ({
  ...props
}) => {
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  return (
    <StyledPaper
      component={Stack}
      width={{
        xs: "clamp(280px, 100%, 570px)",
        md: "700px",
        lg: "900px",
      }}
      elevation={5}
      {...props}
    >
      <Stack
        width="100%"
        direction={{
          xs: "column",
          md: "row",
        }}
      >
        {isXsScreen ? (
          <NavDrawer>
            <ProfileNavBar />
          </NavDrawer>
        ) : (
          <ProfileNavBar />
        )}
        <Stack
          width="100%"
          padding={4}
        >
          <Outlet />
        </Stack>
      </Stack>

    </StyledPaper>
  );
};

export default ProfileLayout;